export const getFireboardChecks = (
  checks = new Map,
  isKiosk,
  isCurbSideOrder,
  isOnline,
  isWalkUp,
  isPosCheck,
  isCallCenter,
  speedOrder,
  isCallIn,
  isCounter,
  driveThru,
) => {
  const curbSideChecks = [];
  const kioskChecks = [];
  const onlineChecks = [];
  const walkUpChecks = [];
  const posChecks = [];
  const callCenter = [];
  const speedOrderChecks = [];
  const callInChecks = [];
  const counterChecks = [];
  const driveThruChecks = [];

  checks.forEach(checkHeader => {
    switch (checkHeader.sourceType) {
      case 5:
        if (isCurbSideOrder) curbSideChecks.push(checkHeader);
        break;
      case 1:
        if (isKiosk) kioskChecks.push(checkHeader);
        break;
      case 6:
        if (isOnline) onlineChecks.push(checkHeader);
        break;
      case 7:
        if (isWalkUp) walkUpChecks.push(checkHeader);
        break;
      case 8:
        if (isCallIn) callInChecks.push(checkHeader);
        break;
      case 9:
        if (isCounter) counterChecks.push(checkHeader);
        break;
      case 10:
        if (isCallCenter) callCenter.push(checkHeader);
        break;
      case 11:
        if (speedOrder) speedOrderChecks.push(checkHeader);
        break;
      case 12:
        if (driveThru) driveThruChecks.push(checkHeader);
        break;
      case 0:
        if (isPosCheck) posChecks.push(checkHeader);
        break;
      // if (checkHeader.tab && isTab) tabChecks.push(checkHeader);
      // else if (!checkHeader.tab && isTable)tableChecks.push(checkHeader);
      default:
        break;
    }
  });

  if (isKiosk) return kioskChecks;
  if (isCurbSideOrder) return curbSideChecks;
  if (isOnline) return onlineChecks;
  if (isWalkUp) return walkUpChecks;
  if (isPosCheck) return posChecks;
  if (isCallCenter) return callCenter;
  if (speedOrder) return speedOrderChecks;
  if (driveThru) return driveThruChecks;
  if (isCallIn) return callInChecks;
  if (isCounter) return counterChecks;
  return [];
};
